import React from 'react';
import PropTypes from 'prop-types';
import RichText from '../Prismic/RichText';
import './HeroIII.scss';

const HeroIII = props => (
  <section className="hero-iii">
    <div className="container-guttered">
      <RichText fields={props.content}/>
    </div>
  </section>
);

HeroIII.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default HeroIII;



// WEBPACK FOOTER //
// ./src/client/js/view/components/HeroIII/HeroIII.js